.menu-link {
  border-bottom: 0.125rem solid transparent;
  text-decoration: none;
  transition: var(--transition-colors) var(--default-duration) var(--default-easing-function);
}

.menu-link:hover,
.menu-link--active {
  border-bottom-color: inherit;
  color: unset;
}

.menu-link--active {
  font-weight: var(--semibold);
}
